import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const API_BASE_URL = 'https://dolphin-app-33jp4.ondigitalocean.app';

function EasyLearnLMS() {
  const navigate = useNavigate();
  const [hasRefAccess, setHasRefAccess] = useState(false);

  // ── Mirror Navbar refAccess logic ─────────────────────────────────────────
  useEffect(() => {
    const checkRefAccess = () => {
      try {
        const userData = localStorage.getItem('userData');
        const user = userData ? JSON.parse(userData) : null;
        if (user && (user.role === 'super_admin' || user.email === 'info@easylearn.net.in')) {
          setHasRefAccess(true); // super admin always has access
        } else {
          setHasRefAccess(localStorage.getItem('refAccess') === '1');
        }
      } catch {
        setHasRefAccess(false);
      }
    };

    checkRefAccess();

    const pollRefAccess = async () => {
      try {
        const userData = localStorage.getItem('userData');
        if (!userData) return;
        const user = JSON.parse(userData);
        if (!user?.email || user.role === 'super_admin' || user.email === 'info@easylearn.net.in') return;
        const res = await fetch(
          `${API_BASE_URL}/isfathena/user/can-access-reference?email=${encodeURIComponent(user.email)}`
        );
        const data = await res.json();
        const newVal = data.can_access ? '1' : '0';
        if (newVal !== localStorage.getItem('refAccess')) {
          localStorage.setItem('refAccess', newVal);
          setHasRefAccess(data.can_access);
        }
      } catch {}
    };

    const handleStorageEvent = (e) => {
      if (e.key === 'refAccessToggle') {
        try {
          const { email, value } = JSON.parse(e.newValue);
          const userData = localStorage.getItem('userData');
          if (userData) {
            const user = JSON.parse(userData);
            if (user.email === email) {
              localStorage.setItem('refAccess', value);
              setHasRefAccess(value === '1');
            }
          }
        } catch {}
      }
      checkRefAccess();
    };

    const pollInterval = setInterval(pollRefAccess, 10000);
    window.addEventListener('storage', handleStorageEvent);
    window.addEventListener('refAccessChange', checkRefAccess);

    return () => {
      clearInterval(pollInterval);
      window.removeEventListener('storage', handleStorageEvent);
      window.removeEventListener('refAccessChange', checkRefAccess);
    };
  }, []);
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 pt-24 sm:pt-32">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            
            {/* Left Content */}
            <div className="space-y-8 z-10">
              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                EasyLearn LMS:<br />
                Revolutionizing Digital<br />
                Education
              </h1>
              
              <p className="text-gray-400 text-lg leading-relaxed">
                Discover the future of learning with EasyLearn LMS at easylearn.org.in - where cutting-edge technology meets educational excellence to transform how institutions deliver knowledge worldwide.
              </p>

              <div className="flex flex-wrap gap-3 sm:gap-4">
                <button className="px-6 sm:px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
                  Get Started Today
                </button>
                <button className="px-8 py-3 border border-white-500 text-white-500 rounded-md font-medium hover:bg-white hover:border-orange-500 hover:text-orange-500 transition">
                  Watch Demo
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative z-10 overflow-hidden rounded-3xl">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-cyan-500/50">
                <img 
                src="/Assests/home_page_23.png" 
                alt="EasyLearn LMS Classroom" 
                className="w-full object-cover h-[400px]"
                />
              </div>
              
              {/* Floating glow effects */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-orange-500/30 rounded-full blur-3xl animate-pulse" />
              <div className="absolute bottom-0 left-0 w-40 h-40 bg-cyan-500/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}} />
            </div>
            
          </div>
        </div>
      </section>

      {/* Chapter 1 Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 mt-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            
            {/* Left Image */}
            <div className="relative z-10">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_24.png" 
                  alt="Global Connectivity" 
                  className="w-full object-cover h-[400px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-8 z-10">
              
              <h3 className="text-3xl lg:text-4xl font-bold text-white">
                The Vision Behind<br />
                EasyLearn
              </h3>
              
              <p className="text-gray-400 text-lg leading-relaxed">
                Every great platform begins with a powerful vision. EasyLearn was born from the belief that quality education should know no boundaries - geographical, economic, or technological.
              </p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Education For All Section */}
    <section className="relative px-4 sm:px-8 lg:px-24 py-20">
    <div className="max-w-7xl mx-auto">
        
        {/* Main Heading */}
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16 text-center">
        Education For All: The Driving Mission
        </h2>

        {/* Bridging the Digital Divide */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-32">
        
        {/* Left Image */}
        <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img 
                src="/Assests/home_page_25.png" 
                alt="Bridging Digital Divide" 
                className="w-full object-cover h-[400px]"
            />
            </div>
        </div>

        {/* Right Content */}
        <div className="space-y-6">
            <h3 className="text-3xl font-bold text-white">
            Bridging the Digital Divide
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed">
            EasyLearn's core mission centers on <span className="text-orange-500">universal access to quality education</span>. We're breaking down barriers by providing institutions with powerful, yet simple tools that make digital learning accessible to everyone.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
            From rural schools to prestigious universities, our platform empowers educators globally with seamless e-learning solutions that adapt to any learning environment.
            </p>
        </div>

        </div>

        {/* The Values That Shape EasyLearn */}
        <div>
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            The Values That Shape EasyLearn
        </h2>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 gap-6">
            
            {/* Respect for Individuals */}
            <div className="bg-black border-2 border-gray-800 rounded-2xl p-8 hover:border-orange-500 transition">
            <div className="w-14 h-14 bg-blue-900/50 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-orange-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
            </div>
            <h4 className="text-2xl font-bold text-white mb-4">
                Respect for Individuals
            </h4>
            <p className="text-gray-400 leading-relaxed">
                User-centric design that honors every learner's unique journey and learning style.
            </p>
            </div>

            {/* Commitment to Simplicity */}
            <div className="bg-black border-2 border-gray-800 rounded-2xl p-8 hover:border-orange-500 transition">
            <div className="w-14 h-14 bg-blue-900/50 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-orange-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                </svg>
            </div>
            <h4 className="text-2xl font-bold text-white mb-4">
                Commitment to Simplicity
            </h4>
            <p className="text-gray-400 leading-relaxed">
                Elegant solutions that eliminate complexity without sacrificing functionality.
            </p>
            </div>

            {/* Security First */}
            <div className="bg-black border-2 border-gray-800 rounded-2xl p-8 hover:border-orange-500 transition">
            <div className="w-14 h-14 bg-blue-900/50 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-orange-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                </svg>
            </div>
            <h4 className="text-2xl font-bold text-white mb-4">
                Security First
            </h4>
            <p className="text-gray-400 leading-relaxed">
                Robust protection for sensitive educational data and user privacy.
            </p>
            </div>

            {/* Scalable Excellence */}
            <div className="bg-black border-2 border-gray-800 rounded-2xl p-8 hover:border-orange-500 transition">
            <div className="w-14 h-14 bg-blue-900/50 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-orange-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
                </svg>
            </div>
            <h4 className="text-2xl font-bold text-white mb-4">
                Scalable Excellence
            </h4>
            <p className="text-gray-400 leading-relaxed">
                Technology that grows with institutions, from startup to enterprise level.
            </p>
            </div>

        </div>
        </div>

    </div>
    </section>

    <section className="relative px-4 sm:px-8 lg:px-24 py-16 ">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            An Integrated Digital Learning Ecosystem
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto">
            EasyLearn is more than just software - it's a complete digital transformation partner for educational institutions seeking to excel in the modern learning landscape.
          </p>
        </div>

        {/* Grid Layout with Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          
          {/* Schools Card */}
          <div className="bg-gradient-to-br from-blue-900/30 to-black border border-blue-500/30 rounded-lg p-4 hover:border-blue-500 transition-all duration-300">
            <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-blue-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Schools</h3>
            <p className="text-gray-300 text-xs leading-relaxed">
              K-12 education with age-appropriate tools and parental engagement features.
            </p>
          </div>

          {/* Junior Colleges Card */}
          <div className="bg-gradient-to-br from-cyan-900/30 to-black border border-cyan-500/30 rounded-lg p-4 hover:border-cyan-500 transition-all duration-300">
            <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-cyan-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Junior Colleges</h3>
            <p className="text-gray-300 text-xs leading-relaxed">
              Advanced coursework management with career preparation resources.
            </p>
          </div>

          {/* Universities Card */}
          <div className="bg-gradient-to-br from-purple-900/30 to-black border border-purple-500/30 rounded-lg p-4 hover:border-purple-500 transition-all duration-300">
            <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-purple-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Universities</h3>
            <p className="text-gray-300 text-xs leading-relaxed">
              Research-grade platform supporting complex academic programs and departments.
            </p>
          </div>

        </div>

        {/* Bottom Info */}
        <div className="text-center mt-6">
          <p className="text-gray-400 text-lg leading-relaxed max-w-4xl mx-auto">
            Our platform is engineered for rapid deployment worldwide, handling large data volumes with enterprise-grade security and{' '}
            <span className="text-orange-500 font-semibold text-lg">99.9% uptime reliability</span>.
          </p>
        </div>

      </div>
    </section>

    <section className="relative px-4 sm:px-8 lg:px-24 py-20 ">
      <div className="max-w-7xl mx-auto">
        
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* Left Content */}
          <div className="space-y-10">
            
            {/* Section Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Embedded Tools for an Immersive Learning Experience
            </h2>

            {/* Live Video Conferencing */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 text-orange-500">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Live Video Conferencing</h3>
              </div>
              <p className="text-gray-400 leading-relaxed sm:pl-16 pl-0">
                HD video sessions with screen sharing, breakout rooms, and recording capabilities for engaging virtual classrooms.
              </p>
            </div>

            {/* Interactive Whiteboard */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 text-orange-500">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Interactive Whiteboard</h3>
              </div>
              <p className="text-gray-400 leading-relaxed sm:pl-16 pl-0">
                Collaborative digital workspace with drawing tools, annotations, and real-time collaboration features.
              </p>
            </div>

            {/* Document Management */}
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border-2 border-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 text-orange-500">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Document Management</h3>
              </div>
              <p className="text-gray-400 leading-relaxed sm:pl-16 pl-0">
                Centralized content library with version control, secure sharing, and multimedia support.
              </p>
            </div>

          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="/Assests/home_page_26.png" 
                alt="Quantum Physics Classroom" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>

        </div>

      </div>
    </section>

    {/* Chapter 3 Header Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 ">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_27.png" 
                  alt="EasyLearn Collaboration" 
                  className="w-full object-cover h-[400px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold text-white">
                Features That Empower Educators and Learners
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed">
                Discover the comprehensive toolkit that makes EasyLearn the preferred choice for educational institutions worldwide.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* User-Friendly Interface Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 ">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Content */}
            <div className="space-y-8">
              <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white">
                User-Friendly Interface & Robust Functionality
              </h2>

              {/* Features Grid */}
              <div className="grid md:grid-cols-2 gap-6">
                
                {/* Intuitive Design */}
                <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-6 hover:border-cyan-500 transition">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Intuitive Design
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Minimal button interface reduces cognitive load, allowing users to focus on learning rather than navigation complexity.
                  </p>
                </div>

                {/* Extensive Integrations */}
                <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-6 hover:border-cyan-500 transition">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Extensive Integrations
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Seamlessly connects with popular educational tools, libraries, and third-party applications to expand learning possibilities.
                  </p>
                </div>

                {/* Real-Time Analytics */}
                <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-6 hover:border-cyan-500 transition md:col-span-2">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Real-Time Analytics
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Comprehensive course statistics and progress tracking provide educators with actionable insights for improved instruction.
                  </p>
                </div>

              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_28.png" 
                  alt="EasyLearn Dashboard" 
                  className="w-full object-cover h-[550px]"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 24/7 Support Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Section Header */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16 text-center">
            24/7 Support and Infrastructure Reliability
          </h2>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
            
            {/* Left Content */}
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-white">
                Always Available When You Need Us
              </h3>
              
              <p className="text-gray-400 leading-relaxed">
                Our <span className="text-orange-500">redundant server architecture</span> ensures near-zero downtime, while our dedicated support team provides round-the-clock assistance for seamless operations.
              </p>

              <p className="text-gray-400 leading-relaxed">
                From technical troubleshooting to feature training, we're committed to your success every step of the way.
              </p>
            </div>

            {/* Right Stats */}
            <div className="grid grid-cols-2 gap-8">
              
              {/* 99.9% Uptime */}
              <div className="text-center">
                <div className="text-6xl font-bold text-orange-500 mb-3">
                  99.9%
                </div>
                <div className="text-xl font-semibold text-white mb-2">
                  Uptime Guarantee
                </div>
                <p className="text-gray-400 text-sm">
                  Reliable infrastructure you can depend on
                </p>
              </div>

              {/* 24/7 Support */}
              <div className="text-center">
                <div className="text-6xl font-bold text-orange-500 mb-3">
                  24/7
                </div>
                <div className="text-xl font-semibold text-white mb-2">
                  Support Available
                </div>
                <p className="text-gray-400 text-sm">
                  Expert assistance whenever needed
                </p>
              </div>

            </div>

          </div>
        </div>
      </section>

      <section className="relative px-4 sm:px-8 lg:px-24 py-12  ">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-orange-500">
            Benefits for Institutions and Students
          </h2>
          <p className="text-gray-400 text-lg">
            Experience the transformative impact EasyLearn brings to educational institutions of all sizes worldwide.
          </p>
        </div>
      </section>

      {/* Transforming Education Delivery */}
      <section className="relative ">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_29.png" 
                  alt="Modern Learning Environment" 
                  className="w-full object-cover h-[400px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-8">
              <h3 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white">
                Transforming Education Delivery
              </h3>

              {/* Extended Learning */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 border border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-orange-500 mb-2">Extended Learning</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Break physical boundaries by enabling continuous learning beyond traditional classroom walls.
                  </p>
                </div>
              </div>

              {/* Flexible Pathways */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 border border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-orange-500 mb-2">Flexible Pathways</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Support diverse skill levels with personalized learning journeys and adaptive content delivery.
                  </p>
                </div>
              </div>

              {/* Rapid Implementation */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 border border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-orange-500 mb-2">Rapid Implementation</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Accelerate digital transformation with intuitive setup and comprehensive customization options.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Cost-Effective and Scalable Solution */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 ">
        <div className="max-w-7xl mx-auto">
          
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16">
            Cost-Effective and Scalable Solution
          </h2>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_30.png" 
                  alt="Smart Investment" 
                  className="w-full object-cover h-[350px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-orange-500">
                Smart Investment in Education
              </h3>
              
              <p className="text-gray-400 leading-relaxed">
                Our cloud-based service model dramatically reduces infrastructure costs while providing enterprise-grade capabilities.
              </p>

              <p className="text-gray-400 leading-relaxed">
                Scale effortlessly from small schools to large universities without additional hardware investments or complex migrations.
              </p>

              {/* Benefits List */}
              <ul className="space-y-3 mt-6">
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Reduced IT overhead costs</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Automatic updates and maintenance</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Flexible pricing models</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-300">Instant global accessibility</span>
                </li>
              </ul>

            </div>

          </div>
        </div>
      </section>

      {/* Real Voices Header */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-16 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-orange-500 mb-4">
            Real Voices from Our Users
          </h2>
          <p className="text-gray-400 text-lg">
            Don't just take our word for it - hear from the educators and institutions who've experienced the EasyLearn difference firsthand.
          </p>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-gradient-to-b from-blue-950/30 to-black">
        <div className="max-w-7xl mx-auto">
          
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Customer Testimonials: Trusted by Educators Worldwide
          </h2>

          {/* Testimonials Grid */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
            
            {/* Testimonial 1 */}
            <div className="relative bg-gradient-to-br from-blue-900/20 to-black border-2 border-orange-500 rounded-2xl p-6">
              {/* Opening Quote */}
              <div className="absolute top-1 left-1 text-4xl text-orange-500 font-serif">"</div>
              
              <div className="mt-4">
                <h4 className="text-xl font-bold text-white mb-2">
                  Tapan Das, ISF Edutech Architect
                </h4>
                <p className="text-gray-300 leading-relaxed mb-4">
                  "The platform's have transformed how we deliver education. It's exactly what we needed."
                </p>
              </div>

              {/* Closing Quote */}
              <div className="absolute bottom-1 right-1 text-4xl text-orange-500 font-serif">"</div>
            </div>

            {/* Testimonial 2 */}
            <div className="relative bg-gradient-to-br from-blue-900/20 to-black border-2 border-orange-500 rounded-2xl p-6">
              {/* Opening Quote */}
              <div className="absolute top-1 left-1 text-4xl text-orange-500 font-serif">"</div>
              
              <div className="mt-4">
                <h4 className="text-xl font-bold text-white mb-2">
                  University Administrator
                </h4>
                <p className="text-gray-300 leading-relaxed mb-4">
                  "We've experienced a completely glitch-free experience with solid programming that supports our most demanding academic programs."
                </p>
              </div>

              {/* Closing Quote */}
              <div className="absolute bottom-1 right-1 text-4xl text-orange-500 font-serif">"</div>
            </div>

            {/* Testimonial 3 */}
            <div className="relative bg-gradient-to-br from-blue-900/20 to-black border-2 border-orange-500 rounded-2xl p-6">
              {/* Opening Quote */}
              <div className="absolute top-1 left-1 text-4xl text-orange-500 font-serif">"</div>
              
              <div className="mt-4">
                <h4 className="text-xl font-bold text-white mb-2">
                  School District Technology Director
                </h4>
                <p className="text-gray-300 leading-relaxed mb-4">
                  "The platform's flexibility and extensive feature set have exceeded our expectations. Implementation was seamless across all our campuses."
                </p>
              </div>

              {/* Closing Quote */}
              <div className="absolute bottom-1 right-1 text-4xl text-orange-500 font-serif">"</div>
            </div>

          </div>
        </div>
      </section>

      {/* Case Study Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_31.png" 
                  alt="Success Masterclass Workshop" 
                  className="w-full object-cover h-[400px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6">
              <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Case Study Snapshot: Seamless Workshop Delivery
              </h2>

              <div className="border-l-4 border-orange-500 pl-6 py-2">
                <p className="text-gray-300 leading-relaxed">
                  "Only 3 visible buttons for participants, while the backend intelligently handles all complexity - this simplified approach led to{' '}
                  <span className="text-orange-500 font-semibold">significantly higher engagement and satisfaction rates</span>."
                </p>
              </div>

              <p className="text-gray-400 leading-relaxed">
                This case study demonstrates how EasyLearn's philosophy of simplicity drives measurable improvements in educational outcomes and user experience.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* How EasyLearn Works Header */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-16 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            How EasyLearn Works
          </h2>
          <p className="text-gray-400 text-lg">
            Discover how easy it is to get started with EasyLearn and begin transforming your educational delivery today.
          </p>
        </div>
      </section>

      {/* Step-by-Step Onboarding */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_32.png" 
                  alt="Success Masterclass" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-8">
              <h3 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white">
                Step-by-Step Onboarding and Usage
              </h3>

              {/* Quick Setup */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 border-2 border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white mb-2">Quick Setup</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Guided configuration wizard adapts the platform for schools, colleges, or universities with custom branding and features.
                  </p>
                </div>
              </div>

              {/* Unified Access */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 border-2 border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white mb-2">Unified Access</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Single dashboard provides seamless access to courses, live sessions, resources, and communication tools.
                  </p>
                </div>
              </div>

              {/* Smart Monitoring */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 border-2 border-gray-700 rounded-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 text-gray-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white mb-2">Smart Monitoring</h4>
                  <p className="text-gray-400 leading-relaxed">
                    Real-time progress tracking and integrated communication keep everyone connected and informed.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Explore Programs Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-gradient-to-b from-gray-900 to-blue-950">
        <div className="max-w-7xl mx-auto">
          
          {/* Section Header */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16">
            Explore Our Programs and Get Started Today
          </h2>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_33.png" 
                  alt="Advanced Learning Technology" 
                  className="w-full object-cover h-[400px]"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold text-white">
                Tailored for Every Institution
              </h3>
              
              <p className="text-gray-300 leading-relaxed">
                Our comprehensive course offerings are specifically designed for different educational levels, ensuring age-appropriate content and methodology.
              </p>

              {/* Programs List */}
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-200">Primary and secondary school curricula</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-200">Junior college specialized programs</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-200">University-level advanced courses</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-200">Professional development workshops</span>
                </li>
              </ul>

              <p className="text-gray-300 leading-relaxed italic">
                Free demo available - experience the platform firsthand before making your decision.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Join the Revolution Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Section Header */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Join the Digital Education Revolution with EasyLearn
          </h2>

          <p className="text-gray-400 text-lg mb-12">
            The future of education is here, and it's more accessible than ever. Visit{' '}
            <a 
              href="https://easylearn.org.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-orange-500 font-semibold hover:underline"
            >
              easylearn.org.in
            </a>{' '}
            to discover how our platform can transform your institution's learning journey.
          </p>

          {/* Cards Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-10">
            
            {/* Transform Today Card */}
            <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-white rounded-2xl p-8 hover:border-orange-500 transition">
              <h3 className="text-2xl font-bold text-white mb-4">
                Transform Today
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Empower your educators with cutting-edge technology that enhances rather than complicates their teaching.
              </p>
            </div>

            {/* Engage Tomorrow Card */}
            <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-white rounded-2xl p-8 hover:border-orange-500 transition">
              <h3 className="text-2xl font-bold text-white mb-4">
                Engage Tomorrow
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Give students the interactive, flexible learning experience they need to succeed in the digital age.
              </p>
            </div>

          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            {/* Reference button — only shown when user has ref access */}
            {hasRefAccess && (
            <button
              onClick={() => navigate('/reffrence?productId=2')}
              className="px-8 py-4 bg-orange-500 text-white text-lg font-semibold rounded-lg hover:bg-orange-600 transition flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
              Reference
            </button>
            )}
            <button className="px-8 py-4 bg-orange-500 text-white text-lg font-semibold rounded-lg hover:bg-orange-600 transition">
              Start Your Journey
            </button>
            <button className="px-8 py-4 border-2 border-white text-white text-lg font-semibold rounded-lg hover:bg-white hover:border-orange-500 hover:text-orange-500 transition">
              Schedule Demo
            </button>
          </div>

        </div>
      </section>

    </div>
  );
}

export default EasyLearnLMS;